import React from 'react';
import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { ChartCard } from '../../dashboard';

export default function HourDistributionChart({ data = [] }) {
  return (
    <ChartCard
      title="In-Time Distribution (Hour)"
      empty={!data.length}
      emptyText="No check-in data"
      emptyHeight={200}
    >
      <ResponsiveContainer width="100%" height={200}>
        <ReBarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
          <XAxis dataKey="hour" tick={{ fontSize: 10, fill: '#94a3b8' }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#94a3b8' }} />
          <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12, border: '1px solid #e5e7eb' }} />
          <Bar dataKey="count" name="Check-ins" fill="#3b82f6" radius={[4, 4, 0, 0]} barSize={22} />
        </ReBarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
